export const Block = {
  referenceContent: "reference-content",
  embed: "block-embed",
  reference: "block-reference",
}
